import { render } from "./RecommendCourseList.vue?vue&type=template&id=7e20943d&ts=true"
import script from "./RecommendCourseList.vue?vue&type=script&lang=ts"
export * from "./RecommendCourseList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__